import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { BrandMark } from 'shared/assets/illustrations';

export function BrandLink({ to = paths.welcome, compact = false }) {
  const { t } = useI18n();
  return (
    <Link to={to} className={compact ? 'brand-link brand-link-compact' : 'brand-link'}>
      <BrandMark />
      <span className="brand-mark">{t('appName')}</span>
    </Link>
  );
}

export function SkipLink() {
  const { t } = useI18n();
  return (
    <a className="skip-link" href="#main">{t('layout.skipToContent')}</a>
  );
}

export function ShellMain({ children, className = '' }) {
  return (
    <main id="main" className={`shell-main ${className}`.trim()}>
      {children}
    </main>
  );
}

export function AppShell({ children, className = '', compactFooter = false, showFooter = true }) {
  const { t } = useI18n();
  return (
    <div className={`app-shell ${className}`.trim()}>
      <SkipLink />
      {children}
      {showFooter ? (
        <footer className={compactFooter ? 'app-footer app-footer-compact' : 'app-footer'}>
          <div className="shell-container footer-inner">
            <p>{t('layout.footerCopy')}</p>
            {compactFooter ? null : (
              <nav className="footer-nav" aria-label={t('layout.footerNavigation')}>
                <Link to={paths.terms}>{t('nav.terms')}</Link>
                <Link to={paths.privacy}>{t('nav.privacy')}</Link>
              </nav>
            )}
          </div>
        </footer>
      ) : null}
    </div>
  );
}
